/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2022-11-22 20:28:58
 * @LastEditors: Monkey
 * @LastEditTime: 2023-01-11 09:01:23
 */
export default {
  ismobile: (state) => state.global.ismobile,
  userName: (state) => state.user.userName,
  filialeId: (state) => state.user.filialeId,

  companyName: (state) => state.company.name,
  companyPerson: (state) => state.company.person,
  companyTel: (state) => state.company.tel
};
